export enum TriggerType {
    ENTER = "Enter",
    SPACE = "Space",
};


export enum ErrorName {
    ABORT_ERROR = "AbortError",
}
